import _pickBy from 'lodash/pickBy';
import camelcaseKeys from 'camelcase-keys';

export const validateSaleSanitizer = filters => {
  const camelcaseRes = camelcaseKeys(filters, { deep: true });
  return _pickBy(camelcaseRes, filter => !!filter || filter === false || filter === 0);
};
